import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ZohoService {
  constructor(private readonly http: HttpClient) {}

  getZohoReport(qParam: string) {
    return this.http.get(`zoho/analytics_views/?${qParam}`);
  }
}
